export default __webpack_public_path__ + "static/media/plus.58d6e4e1.svg";